module.exports = __webpack_public_path__ + "static/media/arrow-right.a2904e0a.svg";